export default "__VITE_ASSET__BWOVDaCg__"